import { useEffect, useState } from 'react';
import { StripePaymentMethod } from 'lib/home/generated/types/api';
import { useMyPaymentMethodsQuery } from 'lib/home/generated/queries';
import { Grid } from 'lib/components';
import { PaymentMethod } from './PaymentMethod';
import { ButtonPrimary, ButtonUnstyled, Icon } from '@lambdacurry/component-library';
import { AddPaymentMethodModal } from './AddPaymentMethod';
import { Empty } from '../Empty/Empty';

export const PaymentMethodList = () => {
  const [addModalOpen, setAddModalOpen] = useState(false);
  const { data, isLoading, isFetching, refetch } = useMyPaymentMethodsQuery(undefined, {
    // NOTE: We disable auto-refetching to support our optimistic updates while we what for mutations to settle
    enabled: false
  });
  const { me } = data || {};
  const paymentMethods = me?.payment_methods || [];

  useEffect(() => {
    // Note: Because we have disabled auto-refetching, we need to fetch/refetch the data manually.
    refetch();
  }, []);

  // Sort so that the default payment method is first.
  const sortedPaymentMethods = paymentMethods.sort((a, b) => (a.is_default ? -1 : 1));

  return (
    <>
      {!isLoading && !isFetching && paymentMethods.length < 1 && (
        <Empty
          title="You haven't added a payment method yet."
          actions={<ButtonPrimary onClick={() => setAddModalOpen(true)}>Add A Payment Method</ButtonPrimary>}
        />
      )}

      {sortedPaymentMethods.length > 0 && (
        <Grid className="payment-method__list mt-6 mb-12 !gap-4 md:!gap-6" data-cy="payment-method-list">
          {paymentMethods.map(paymentMethod => (
            <div key={paymentMethod.id} className="payment-method__list__item col-span-12">
              <PaymentMethod paymentMethod={paymentMethod as StripePaymentMethod} />
            </div>
          ))}
          <div className="payment-method__list__item payment-method__list__add-button col-span-12">
            <ButtonUnstyled
              className="flex !flex-col w-full gap-3 !p-16 !border !border-solid !border-brand-green-500 hover:!border hover:!border-solid hover:!border-primary transition-all"
              onClick={() => setAddModalOpen(true)}
              icon={<Icon name="add" />}
              data-cy="add-payment-method-button"
            >
              <span className="font-bold">Add Another Card</span>
            </ButtonUnstyled>
          </div>
        </Grid>
      )}

      {addModalOpen && (
        <AddPaymentMethodModal
          isOpen={addModalOpen}
          redirectPath="/account/payment-methods"
          onAfterClose={() => setAddModalOpen(false)}
          onSave={() => setAddModalOpen(false)}
          onCancel={() => setAddModalOpen(false)}
        />
      )}
    </>
  );
};
